import React, { useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server'
import { Button, Card, CardContent, Fab, Grid, Typography, Collapse, Divider, Tooltip, FormControlLabel, Checkbox, Modal, useMediaQuery } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import Swal from 'sweetalert2';
import { guardarDatosMatriculas } from 'app/features/Matriculas/matriculasApi';
import { useSelector, useDispatch } from 'react-redux';
import { getProfesionalValidarCuit } from 'app/features/Profesionales/profesionalesAPI';
import { estadoCivilList, getEstadoCivilAsync } from 'app/features/EstadoCivil/estadoCilvilSlice';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { FormDatosPersonales } from './FormDatosPersonales';
import EditIcon from '@mui/icons-material/Edit';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import { Domicilios } from './Domicilios';
import { GrupoFamiliar } from './GrupoFamiliar';
import { nuevoAdjunto } from 'utils/adjuntosLogic';
import { ModalDomicilio } from 'components/domiciliosRR/ModalDomicilio';
import { getTipoCalleAsync } from 'app/features/TipoCalles/tipoCallesSilice';
import { useTheme } from '@material-ui/core';
import { LINK } from 'constants/routes/endpoints';
import WarningIcon from '@mui/icons-material/Warning';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const useStyles = makeStyles(theme => ({
    select: {
        width: '100%',
        backgroundColor: 'red'
    },
    button: {
        display: "flex!important",
        justifyContent: "flex-end!important"
    },
    color_texto_aclaracion: {
        color: 'gray',
        fontSize: 1
    },
    color_rojo: {
        color: 'red'
    },
    option: {
        fontWeight: 'bold',
        color: 'black'
    },
}));

export const DatosPersonalesYFamiliares = ({ datos, libraries, bloquearBtn, setDatos, setValue, ObrasSociales, loaderBtnGuardar, setLoaderBtnGuardar, setBloquearBtn, idEstado, setMatriculas, setCantidadTramites, tpoUser, location, setLocation, datosModificados, datosDomicilioModificados, datosFamiliarModificados }) => {

    const dispatch = useDispatch()
    const [errorCuit, setErrorCuit] = useState({ display: "none" });
    const [deshabilitarCampo, setDeshabilitarCampo] = useState(false);
    const [open1, setOpen1] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [open3, setOpen3] = useState(true);
    const [openModal1, setOpenModal1] = useState(false);
    const [openModalDomicilio, setOpenModalDomicilio] = useState(false);
    const EstadoCivilList = useSelector(estadoCivilList);
    const tipoUsuario = Number(localStorage.userType);
    const editarFotoSlice = useSelector(state => state.editarDatosProfesionalReducer);
    const [confirmaDomicilios, setConfirmaDomicilios] = useState(false);
    const [tipoCalleSelect, setTipoCalleSelect] = useState([]);

    const estadoCivilDescripcion = EstadoCivilList.find(estado => estado.estadoCivil === datos.EstadoCivil)?.descripcion;
    const datosModificadosFiltrado = datosModificados.filter(dato => dato !== 'Email');
    const tpoTramite = Number(localStorage.tpoTramite);
    const datosPersonalesFiltrados = tpoTramite === 3 ? datosModificados.filter(prop => prop !== 'Email' && prop !== 'Celular') : datosModificados.filter(prop => prop !== 'Email')

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));

    const onContinue = () => {
        if(idEstado !== 1) {
            onSubmit();
            return;
        }

        Swal.fire({
            html: `
                <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;">
                    ${renderToString(<WarningAmberIcon style={{ color: '#fbc02d', fontSize: '4em', marginBottom: '1rem', marginTop: '1rem' }} />)}
                    <div style="font-size:1.5em;margin-bottom:8px;text-align:center;margin-bottom:1rem">
                        <b>Advertencia legal</b>
                    </div>
                    <div style="text-align:center;">
                        Sin matrícula vigente, el ejercicio de la profesión en la Provincia de Buenos Aires es ilegal e infrinje la Ley 10.620. <br/><br/>
                        ¿Desea continuar con la cancelación?
                    </div>
                </div>
            `,
            // icon: 'warning',
            showCloseButton: false,
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            width: '50vw'
        }).then((result) => {
            if (result.isConfirmed) {
               onSubmit();
            } else {
                window.location.href = LINK;
            }
        })
    }

    const onSubmit = data => {
        

        let erroresMostrar = "";
        let mostrarErrorDomicilio = 0;
        let documento = datos.NroDocumento;
        let contadorConfirmados = 0;
        documento = documento.replace(/\./g, '').replace(/[a-z ]/g, "");
        let cuit = datos.CuitCuil;
        cuit = cuit.substring(3);
        cuit = cuit.substring(0, 8);

        datos.domicilios.forEach((domicilio) => {
            if (domicilio.confirmaDomicilio === true) {
                contadorConfirmados++;
            }
        });
        // setConfirmaDomicilios(contadorConfirmados === 5);

        if (contadorConfirmados < 5) {
            Swal.fire({
                title: 'Atención', html: 'Le falta confirmar 1 o más domicilios',
                icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
            })
            return false;
        }

        if (cuit.startsWith("0")) {
            cuit = cuit.substring(1);
        }

        if (datos.CuitCuil.length !== 13 || cuit !== documento) {
            Swal.fire({
                title: 'Atención', html: 'El CUIT-CUIL ingresado no es valido',
                icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
            })
            return false;
        }

        if (!editarFotoSlice.fotoActual && !editarFotoSlice.fotoNueva && tpoTramite !== 3) {
            Swal.fire({ title: 'Atención', html: 'Debe cargar una foto actual', icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true });
            return false;
        }

        if (datos.EstadoCivil === '') {
            Swal.fire({ title: 'Atención', html: 'Debe seleccionar un estado civil', icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true });
            return false;
        }

        if (datos.Nacionalidad === '') {
            Swal.fire({ title: 'Atención', html: 'Debe seleccionar una nacionalidad', icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true });
            return false;
        }

        if (datos.ObraSocial === '' || datos.ObraSocial === 'Sin Datos') {
            Swal.fire({ title: 'Atención', html: 'Debe seleccionar una obra social', icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true });
            return false;
        }

        datos.domicilios.map((domicilio, index) => {

            const errores = [];

            if (domicilio.calle === "") errores.push("calle");
            if (domicilio.celular === "" && tpoTramite !== 3) errores.push("celular");
            if (domicilio.caracteristica === null && tpoTramite !== 3) errores.push("característica");
            if (domicilio.caracteristica && domicilio.caracteristica.length > 5 && tpoTramite !== 3) errores.push("característica (longitud mayor a 5)");
            if (domicilio.caracteristicaFijo && domicilio.caracteristicaFijo.length > 5) errores.push("característica fija (longitud mayor a 5)");
            if (isNaN(domicilio.caracteristica) && tpoTramite !== 3) errores.push("característica (no es un número)");
            if (isNaN(domicilio.celular) && tpoTramite !== 3) errores.push("celular (no es un número)");


            if (errores.length > 0 && mostrarErrorDomicilio === 0) {
                if (erroresMostrar !== "") erroresMostrar += ", ";
                erroresMostrar += `<b>Domicilios</b>: ${errores.join(", ")}`;
                mostrarErrorDomicilio = 1;
            }

        })

        if (erroresMostrar !== "") {
            Swal.fire({
                title: 'Atención', html: 'Debe completar correctamente los siguientes datos:' + erroresMostrar,
                icon: 'warning', showCloseButton: true, showCancelButton: false,
                confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
            });
            return false;
        }

        if (editarFotoSlice.deseaCambiarFoto) {
            let adjuntoDeFoto = datos.adjuntos.find(a => a.fileType === "FotoPerfil");
            if (adjuntoDeFoto) {
                adjuntoDeFoto.file = editarFotoSlice.fotoNueva;
            } else {
                adjuntoDeFoto = nuevoAdjunto("FotoPerfil", "image/jpeg", editarFotoSlice.fotoNueva);
                datos.adjuntos.push(adjuntoDeFoto);
            }
            let adjuntoDeFotoFull = datos.adjuntos.find(a => a.fileType === "FotoPerfilFull");
            if (adjuntoDeFotoFull) {
                adjuntoDeFotoFull.file = editarFotoSlice.fotoNuevaFullSize;
            } else {
                adjuntoDeFotoFull = nuevoAdjunto("FotoPerfilFull", "image/jpeg", editarFotoSlice.fotoNuevaFullSize);
                datos.adjuntos.push(adjuntoDeFotoFull);
            }


        }

        const merged = {...datos};
            
        if(localStorage.tpoTramite === "3" && idEstado === 6){
            delete merged.fechaCancelacion;
        } 

        getProfesionalValidarCuit(datos.CuitCuil.replace(/-/gi, '')).then((value) => {
            if (!value.data.response) {
                setErrorCuit({ display: '' })
                Swal.fire({
                    title: 'Atención', html: 'El CUIT-CUIL ingresado no es valido',
                    icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
                })
                return false;
            } else {
                setLoaderBtnGuardar(true)
                setBloquearBtn(true);
                guardarDatosMatriculas({ datos: JSON.stringify(merged), estado: idEstado, tpo_tramite: Number(localStorage.tpoTramite) }).then(async (value) => {
                    setMatriculas(value.data);
                    setLoaderBtnGuardar(false);
                    setBloquearBtn(false);
                    if (value.data.resultado) {
                        setValue("5");
                    } else {
                        Swal.fire({
                            title: 'Atención', html: value.data.mensaje !== '' && value.data.mensaje !== null ? value.data.mensaje : 'Ocurrio un error al guardar los datos. Por favor vuelva a intentarlo',
                            icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
                        })
                        return false;
                    }
                });
            }
        });
    }

    const goBack = () => {
        Swal.fire({
            title: 'Atención', html: 'Si oprime aceptar, deberá volver a confirmar todos los domicilios nuevamente <br/> ¿Está seguro que desea volver atrás?',
            icon: 'warning', showCloseButton: false, showCancelButton: true, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
        }).then((result) => {
            if (result.isConfirmed) {
                const domiciliosArr = datos.domicilios.map((domicilio) => ({
                    ...domicilio,
                    confirmaDomicilio: false
                }));

                setDatos({
                    ...datos,
                    domicilios: domiciliosArr
                });

                setValue("3");
            }
        })
    }

    const handleChangeTab = () => {
        setValue("5");
    };


    useEffect(() => {
        if (EstadoCivilList.length === 0) {
            dispatch(getEstadoCivilAsync());
        }
    }, [])

    useEffect(() => {
        dispatch(getTipoCalleAsync()).then(response => {
            let tipoCalle = [];

            response.payload.map(tpoCalle => {
                tipoCalle.push({ value: tpoCalle.tpoCalle, label: tpoCalle.denTpoCalle })
            })

            setTipoCalleSelect(tipoCalle);
        })
    }, [])

    return (
        <>
            <Typography style={{ fontSize: 16 }} mb={2}>
                <b>Verificar información.</b>
            </Typography>
            <Grid container direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent={{ xs: 'flex-start' }} pb={2} >
                <Grid item sx={{ mb: { xs: 1, md: 0 }, mr: { xs: 0, md: 2 } }}>
                    <Typography fontSize={18}>
                        Datos Personales
                        {
                            datosPersonalesFiltrados.length > 0 &&
                            <Tooltip
                                title={`Se han modificado los siguientes datos: ${datosPersonalesFiltrados.length > 1
                                    ? datosPersonalesFiltrados.join(", ")
                                    : datosPersonalesFiltrados
                                    }`}
                                placement="right"
                            >
                                <WarningAmberOutlinedIcon sx={{ color: 'red !important', ml: 1 }} />
                            </Tooltip>
                        }
                    </Typography>
                </Grid>

                <Grid item display='flex' sx={{ width: { xs: '100%', md: '60%' }, position: 'relative' }}>
                    <Card
                        sx={{ boxShadow: 5, background: '#e4f0ec', width: '100%', borderColor: '#b8daba', borderRadius: '5px', border: '3px solid #b8daba', mb: { xs: 2, md: 0 } }} >
                        <CardContent>
                            <Grid container>
                                <Grid item xs={12} md={12} mt={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography>Estado Civil: <b>{estadoCivilDescripcion}</b></Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography>Nacionalidad: <b>{datos.Nacionalidad}</b></Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} mt={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography>CUIT/CUIL: <b>{datos.CuitCuil}</b></Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography>Obra Social: <b>{datos.ObraSocial}</b></Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    {(localStorage.userType !== "1" && bloquearBtn !== true) &&
                        <Fab
                            size="small"
                            color="secondary"
                            aria-label="edit"
                            onClick={() => setOpenModal1(true)}
                            sx={{ ml: { xs: 0, md: 2 }, position: { xs: 'absolute', md: 'relative' }, top: { xs: '0.5em', md: 'auto' }, right: { xs: '0.5em', md: 'auto' } }} >
                            <EditIcon />
                        </Fab>
                    }
                </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />

            <Grid display='flex' alignItems='center' pb={2}>

                <Typography fontSize={18}> Grupo Familiar Primario  </Typography>
                {
                    datosFamiliarModificados.length > 0 &&
                    <Tooltip
                        title={`Se han modificado los siguientes datos: ${datosFamiliarModificados.length > 1
                            ? datosFamiliarModificados.map(dato => dato.changedProperties.filter(prop => prop !== 'estado').map(prop => prop === 'codNacionalidad' ? 'Nacionalidad' : prop).join(", ")).join("; ")
                            : datosFamiliarModificados[0].changedProperties.filter(prop => prop !== 'estado').map(prop => prop === 'codNacionalidad' ? 'Nacionalidad' : prop).join(", ")}`}
                        placement="right"
                    >
                        <WarningAmberOutlinedIcon sx={{ color: 'red !important', ml: 1 }} />
                    </Tooltip>
                }
            </Grid>
            <Grid container>
                <GrupoFamiliar datos={datos} setDatos={setDatos} bloquearBtn={bloquearBtn} setBloquearBtn={setBloquearBtn} setValue={setValue} ObrasSociales={ObrasSociales} idEstado={idEstado} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} setMatriculas={setMatriculas} />
            </Grid>
            <Grid container>
                <Grid item md={6} xs={6} sx={{ mt: 3 }} >
                    <Button startIcon={<ArrowBackIosIcon />} onClick={goBack} variant="contained" type="submit" color="error" disabled={bloquearBtn} >
                        Atras
                    </Button>
                </Grid>
                <Grid item md={6} xs={6}>
                    <Grid sx={{ mt: 3 }} container justifyContent="flex-end">
                        <Button disabled={bloquearBtn} endIcon={<ArrowForwardIosIcon />} onClick={tpoTramite === 3 ? onContinue : onSubmit} variant="contained" color="secondary">
                            {loaderBtnGuardar ? (isXs ? (<CircularProgress size={25} />) : (<><CircularProgress size={25} /> Continuar </>)) : ('Continuar')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            {
                openModal1 &&
                <FormDatosPersonales datos={datos} bloquearBtn={bloquearBtn} setBloquearBtn={setBloquearBtn} setDatos={setDatos} setValue={setValue} ObrasSociales={ObrasSociales} idEstado={idEstado} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} setMatriculas={setMatriculas} open={openModal1} setOpen={setOpenModal1} EstadoCivilList={EstadoCivilList} />
            }

        </>
    );
}